.container {
  margin: 32px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.icon {
  width: 300px;
  height: 300px;
}

.heading {
  margin-bottom: 64px;
}
